let lockCount = 0
let savedScrollY = 0

function isInsideLockCard(target: EventTarget | null) {
    const el = target as HTMLElement | null
    return Boolean(el && typeof el.closest === 'function' && el.closest('.lock-card'))
}

function onLockTouchMove(event: TouchEvent) {
    if (isInsideLockCard(event.target)) return
    event.preventDefault()
}

export function lockBodyScroll() {
    lockCount += 1
    if (lockCount !== 1) return

    savedScrollY = window.scrollY || window.pageYOffset || 0
    document.documentElement.classList.add('billing-lock-no-scroll')
    document.body.classList.add('billing-lock-no-scroll')
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.width = '100%'
    document.addEventListener('touchmove', onLockTouchMove, { passive: false })
}

export function unlockBodyScroll() {
    if (lockCount === 0) return
    lockCount -= 1
    if (lockCount > 0) return

    document.removeEventListener('touchmove', onLockTouchMove)
    document.documentElement.classList.remove('billing-lock-no-scroll')
    document.body.classList.remove('billing-lock-no-scroll')
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.width = ''
    window.scrollTo(0, savedScrollY)
}
